export const CREATE_PROJECT = 'app/CreateProject/CREATE_PROJECT'
export const COPY_PROJECT = 'app/CreateProject/COPY_PROJECT'
export const PROJECT_CREATED = 'app/CreateProject/PROJECT_CREATED'
export const CREATE_PROJECT_ERROR = 'app/CreateProject/CREATE_PROJECT_ERROR'
export const CLEAR_CREATE_PROJECT = 'app/CreateProject/CLEAR_CREATE_PROJECT'
export const NAME_NOT_AVAILABLE = 'app/CreateProject/NAME_NOT_AVAILABLE'
